import { handleActions } from 'redux-actions';
import initialState from './states';
import { logoutSuccess } from 'ducks/auth/actions';
import {
  biSiteVisitsByDateSuccess,
  biSiteVisitsBySiteAndDateSuccess,
  biSiteVisitsSuccess,
  setLoadingState,
} from './actions';

export default handleActions(
  {
    [biSiteVisitsSuccess](state, { payload }) {
      return {
        ...state,
        list: payload,
      };
    },
    [biSiteVisitsByDateSuccess](state, { payload }) {
      return {
        ...state,
        byDate: payload,
      };
    },
    [biSiteVisitsBySiteAndDateSuccess](state, { payload }) {
      return {
        ...state,
        bySiteAndDate: payload,
      };
    },
    [setLoadingState](state, { payload }) {
      return {
        ...state,
        loading: payload,
      };
    },
    [logoutSuccess]() {
      return initialState;
    },
  },
  initialState
);
